import { lazy } from 'react';

// Optimized with webpackPrefetch hint for faster loading
export const LazySignUp = lazy(() => 
  import(/* webpackPrefetch: true */ '@/pages/SignUp')
);
